<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="isDisabled" [multiple]="multiple"
           [placeholder]="'hx.bank-select.selectBank' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.id">{{op.name}}</ng-option>
</ng-select>
